<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <h2>Blog</h2>
        </div>
    </div>
    <div class="shape9"><img src="assets/img/shape8.svg" alt="image"></div>
</div>
<div class="blog-area ptb-100">
    <div class="container">
        <div class="row">
            <div class="col-lg-4 col-md-6">
                <div class="single-post-box">
                    <div class="post-image">
                        <a routerLink="/blog/how-to-get-admission-open" class="d-block">
                            <img src="assets/img/blog/how-to-get-admission-open.png" alt="image">
                        </a>
                    </div>
                    <div class="post-content shadow-lg p-3 mb-5 bg-white rounded" style="margin-top: -32px;">
                        <h3 class="inter-font"><a routerLink="/blog/how-to-get-admission-open"
                                                  style="font-weight: 400;font-size: 18px;">How to get admission in
                            Subharti
                            University?</a></h3>
                        <ul class="post-content-footer d-flex justify-content-between align-items-center">
                            <li>
                                <div class="post-author d-flex align-items-center">
                                    <a routerLink="blog/how-to-get-admission-open"> <span style="font-weight: normal;">In 2008, Swami Vivekananda Subharti University was founded in Meerut, Uttar Pradesh.</span></a>
                                </div>
                            </li>
                            <li><a routerLink="/blog/how-to-get-admission-open" class="link-btn"><i
                                class='bx bx-right-arrow-alt'></i></a></li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="single-post-box">
                    <div class="post-image">
                        <a routerLink="/blog/is-subharti-university-good-for-distance-mba" class="d-block">
                            <img src="assets/img/blog/is-subharti-good.png" alt="image">
                        </a>
                    </div>
                    <div class="post-content shadow-lg p-3 mb-5 bg-white rounded" style="margin-top: -32px;">
                        <h3 class="inter-font"><a routerLink="/blog/is-subharti-university-good-for-distance-mba"
                                                  style="font-weight: 400;font-size: 18px;">Is Subharti
                            University Good for Distance
                            MBA</a></h3>
                        <ul class="post-content-footer d-flex justify-content-between align-items-center">
                            <li>
                                <div class="post-author d-flex align-items-center">
                                    <a routerLink="/blog/is-subharti-university-good-for-distance-mba"><span
                                        style="font-weight: normal;">Subharti, which was founded in 2008, offers India's best distance learning programme.</span>
                                    </a>
                                </div>
                            </li>
                            <li><a routerLink="/blog/is-subharti-university-good-for-distance-mba" class="link-btn"><i
                                class='bx bx-right-arrow-alt'></i></a></li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="single-post-box">
                    <div class="post-image">
                        <a routerLink="/blog/why-choose-subharti-university-for-distance-learning" class="d-block">
                            <img src="assets/img/blog/why-choose-subharti.png" alt="image">
                        </a>
                    </div>
                    <div class="post-content shadow-lg p-3 mb-5 bg-white rounded" style="margin-top: -32px;">
                        <h3 class="inter-font"><a
                            routerLink="/blog/why-choose-subharti-university-for-distance-learning"
                            style="font-weight: 400;font-size: 18px;">Why
                            choose Subharti university for Distance learning?</a></h3>
                        <ul class="post-content-footer d-flex justify-content-between align-items-center">
                            <li>
                                <div class="post-author d-flex align-items-center">
                                    <a routerLink="/blog/why-choose-subharti-university-for-distance-learning"> <span
                                        style="font-weight: normal;">One of Uttar Pradesh's top public universities is Subharti University.</span>
                                        <br>
                                        <br>
                                    </a>
                                </div>
                            </li>
                            <li><a routerLink="/blog/why-choose-subharti-university-for-distance-learning"
                                   class="link-btn"><i
                                class='bx bx-right-arrow-alt'></i></a></li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="single-post-box">
                    <div class="post-image">
                        <a routerLink="/blog/is-subharti-university-degree-valid-for-government-job" class="d-block">
                            <img src="assets/img/blog/is-subharti-uni-degree-valid.png" alt="image">
                        </a>
                    </div>
                    <div class="post-content shadow-lg p-3 mb-5 bg-white rounded" style="margin-top: -32px;">
                        <h3 class="inter-font"><a
                            routerLink="/blog/is-subharti-university-degree-valid-for-government-job"
                            style="font-weight: 400;font-size: 18px;">Is
                            Subharti's university degree valid for government jobs?</a></h3>
                        <ul class="post-content-footer d-flex justify-content-between align-items-center">
                            <li>
                                <div class="post-author d-flex align-items-center">
                                    <!--<img src="assets/img/user/user3.jpg" class="rounded-circle" alt="image">-->
                                    <a routerLink="/blog/is-subharti-university-degree-valid-for-government-job"> <span
                                        style="font-weight: normal;">In 2008, Swami Vivekanand Subharti University was created..</span>
                                    </a>
                                </div>
                            </li>
                            <li><a routerLink="/blog/is-subharti-university-degree-valid-for-government-job"
                                   class="link-btn"><i
                                class='bx bx-right-arrow-alt'></i></a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
